import {ApiClientService, EntityApiService} from '@dofleini/security';
import {authentication} from '@/settings';
import {stringifyTranslatePayload} from '@/utils/createTranslatedPayload';

class SpaceSettingApiService extends EntityApiService {

  getCurrentSpace = () => {
    return ApiClientService.get(this.getPath() + '/current');
  }

  updateSetting = (params) => ApiClientService.patch(this.getPath(`/${params._id}`), params, {transformRequest: [stringifyTranslatePayload]});
}

export default new SpaceSettingApiService(`${authentication.path}/api/spaces`);
